<template>
  <div class="w-full">
    <div class="relative">
      <span class="absolute inset-y-0 left-0 flex items-center pl-4" v-html="icon"></span>
      <input
        type="text"
        class="w-full rounded-[3.125rem] bg-white pl-11 pr-4 py-3 text-sm shadow-[0_0_20px_0_rgba(191,197,245,0.15)] focus:outline-none focus:ring-2 focus:ring-accent/40 placeholder-transparent"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
const searchIconSvg = `<svg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17' fill='none'>
  <g clip-path='url(#clip0_4480_1264)'>
    <path d='M7.30827 0L8.2446 0.142552C11.9332 0.929245 14.2889 4.51695 13.5385 8.24102C13.3331 9.26013 12.8559 10.1969 12.2573 11.0354L16.7353 15.5218C16.8655 15.6515 16.9266 15.8073 17 15.9707V16.3027C16.8934 16.6596 16.6578 16.8937 16.3032 17H16.0044L15.5391 16.7512L11.0376 12.2542C10.4506 12.6654 9.82994 13.04 9.15082 13.2817C5.18194 14.6948 0.888116 12.2108 0.121788 8.102L0.00624147 7.30469C0.0204081 6.99922 -0.0132377 6.6787 0.00624147 6.375C0.223169 2.98563 3.03746 0.216042 6.41223 0H7.30827ZM6.60437 1.7031C2.56023 1.91648 0.272752 6.51888 2.6678 9.83875C4.86319 12.8819 9.49968 12.6305 11.3303 9.35266C13.2879 5.84641 10.6073 1.49237 6.60481 1.70354L6.60437 1.7031Z' fill='#61656A'/>
  </g>
  <defs>
    <clipPath id='clip0_4480_1264'>
      <rect width='17' height='17' fill='white'/>
    </clipPath>
  </defs>
</svg>`;
export default {
  name: 'SearchBar',
  props: {
    modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '' }
  },
  data(){
    return { icon: searchIconSvg };
  },
  emits: ['update:modelValue']
}
</script>
